export const checkNoIdentity = (error: any) => {
  return error?.response?.body?.error?.message?.includes(
    'unexpected number of identities'
  )
}
